import { parseError } from '@yuno/sdk-web-core/dist/utils/parse-error'
import { FC } from 'react'
import { useRouteError } from 'react-router-dom'
import { StatusCanceled, StatusExpired, StatusError, StatusUsed, StatusInactive } from '../status'
import { dispatchLoaderEvent } from '../../utils/loader'

export const ErrorBoundary: FC = () => {
  const error = parseError(useRouteError())

  dispatchLoaderEvent({ showLoader: false })
  if (error.context?.code === 'LINK_EXPIRED') {
    return <StatusExpired />
  }

  if (error.context?.code === 'LINK_CANCELED') {
    return <StatusCanceled />
  }

  if (error.context?.code === 'LINK_INACTIVE') {
    return <StatusInactive />
  }

  if (error.context?.code === 'LINK_USED') {
    return <StatusUsed />
  }

  return <StatusError />
}
